"use client";

import { createContext, useContext } from "react";

type AdminContextValue = {
  isAdmin: boolean;
};

const AdminCtx = createContext<AdminContextValue>({ isAdmin: false });

export function AdminProvider({
  isAdmin,
  children,
}: {
  isAdmin: boolean;
  children: React.ReactNode;
}) {
  return (
    <AdminCtx.Provider value={{ isAdmin }}>{children}</AdminCtx.Provider>
  );
}

export function useAdmin(): boolean {
  return useContext(AdminCtx).isAdmin;
}
